export default __webpack_public_path__ + "static/media/mario-cat-friends.1f861144.webp";